import React, { Component } from 'react'
import { Link } from 'react-router'
import './index.less'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import langM from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import score from 'src/helper/score'
import History from './History/index'
import Rank from './Rank/index'
import Rule from './Rule/index'
import Timer from './Timer/index'

import { closeWebview } from 'src/helper/webviewFun'
import { toJS } from 'mobx'

@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.lotteryStore = this.props.store.register('activity/lottery')
    // 防抖
    // this.rankData = debounce(this.rankData, 1000)
    // this.HisData = debounce(this.HisData, 1000)
  }

  leftTime = 0

  state = {
    // 选中金额
    stakeObj: 100,
    // 金币节点
    domList1: [],
    domList2: [],
    domList3: [],
    domList4: [],
    domList5: [],

    // 不同宝石选择判断，控制宝石选中背景
    domState: '0',
    // 顶部几个功能的切换
    funcTabBarRule: '1',
    funcTabBarHis: '0',
    funcTabBarRank: '0',
    // 计时时间
    stateTime: -1,

    // by lucas
    gem1tmp: {
      number: 0,
      gold: 0
    },
    gem2tmp: {
      number: 0,
      gold: 0
    },
    gem3tmp: {
      number: 0,
      gold: 0
    },
    gem4tmp: {
      number: 0,
      gold: 0
    },
    gem5tmp: {
      number: 0,
      gold: 0
    },
    coins1: 100,
    coins2: 500,
    coins3: 1000,
    coins4: 5000,
    coins5: 10000,
    canRunTimer: 0, //定时器
    leftTime: 0,
    // by lucas end
    stateLottery: 1,
    stateMask: 1,

    // 5宝石
    gem1: {
      number: 0,
      gold: 0
    },
    gem2: {
      number: 0,
      gold: 0
    },
    gem3: {
      number: 0,
      gold: 0
    },
    gem4: {
      number: 0,
      gold: 0
    },
    gem5: {
      number: 0,
      gold: 0
    },
    wheels: [
      { wheelId: 0, coins: 0 },
      { wheelId: 1, coins: 0 },
      { wheelId: 2, coins: 0 },
      { wheelId: 3, coins: 0 },
      { wheelId: 4, coins: 0 }
    ],
    rounds: 0,
    showDeg: '',
    overtime: null,
    goldEnough: 1,
    showThisResult: false,
    mp3: 'img/activity/lottery/coins.mp3',
    mp3Lottery: 'img/activity/lottery/lotterygo.mp3',
    gemArr: [],
    language:'en',
    lang:langM.en,
  }

  componentDidMount() {
    setDocumentTitle('Lottery')
  }
  async componentWillMount() {
    let { language } = this.props.location.query
    language =await getlang(language)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    let uid = await setUidToken(this.props.location.query)
    await this.RunOnStart(uid)
  }

  async closeWebview() {
    closeWebview()
  }
  returnleftTime = async () => {
    return this.leftTime
  }

  RunOnStart = async (uid) => {
    this.setState({ uid: uid })
    this.lotteryStore.GetUserInfoWeb(uid)
    this.lotteryStore.getBetRank()
    this.lotteryStore.getBetHistory()

    let { canBet, date, round, tsNow, tsZero } = await this.lotteryStore.GetLotteryTime()

    // by lucas
    // 倒计时
    setInterval(async () => {
      if (this.state.canRunTimer > 0) {
        this.setState({
          canRunTimer: this.state.canRunTimer - 1
        })
      }
    }, 1000)
    // by lucas end

    // 倒计时
    setInterval(async () => {
      let timestamp = Date.parse(new Date()) / 1000 //当前时间
      // if (((timestamp - tsNow) < 40) && ((timestamp - tsNow) > -40)) {
      //   tsNow = timestamp
      // }
      // console.log(tsNow)

      let leftTime = (tsNow - tsZero) % 45

      // by lucas
      // this.setState({
      //   leftTime: leftTime
      // })

      this.leftTime = leftTime

      if (leftTime == 0) {
        console.log('场上清空金币节点以及押注额')
        this.lotteryStore.clearBet()
        this.resetBet()
        this.lotteryStore.GetLotteryTime()
        this.lotteryStore.setBetFruit()
      }

      if (leftTime <= 30 && this.state.stateLottery != 1) {
        this.setState({
          stateLottery: 1
        })
      } else if (leftTime > 30 && leftTime < 40 && this.state.stateLottery != 2) {
        this.setState({
          stateLottery: 2
        })
      } else if (leftTime >= 40 && this.state.stateLottery != 3) {
        this.setState({
          stateLottery: 3
        })
      }
      if (leftTime >= 0 && leftTime <= 28 && this.state.stateMask != 2) {
        this.setState({
          stateMask: 2
        })
      } else if (leftTime >= 28 && leftTime <= 45 && this.state.stateMask != 1) {
        this.setState({
          stateMask: 1
        })
      }

      if (leftTime == 44) {
        // by lucas
        this.setState({
          gem1tmp: {
            number: 0,
            gold: 0
          },
          gem2tmp: {
            number: 0,
            gold: 0
          },
          gem3tmp: {
            number: 0,
            gold: 0
          },
          gem4tmp: {
            number: 0,
            gold: 0
          },
          gem5tmp: {
            number: 0,
            gold: 0
          }
        })
      }

      this.postGoldToHost(leftTime)

      if (leftTime == 12 || leftTime == 16 || leftTime == 20 || leftTime == 24 || leftTime == 30 || leftTime == 31 || leftTime == 32) {
        this.lotteryStore.getAllBet()
      }
      if (leftTime == 37) {
        this.lotteryStore.BetResult()
        this.lotteryStore.changeIsEnd()
      }
      if (leftTime == 40) {
        // 获得金币是否大于0
        let { rewardCoins } = this.lotteryStore.data
        if (this.state.showThisResult != true) {
          this.setState({
            showThisResult: true
          })
        }

        let betResult = this.lotteryStore.data.betResult
        let res = ''
        let overtime = null
        if (overtime == -2) {
          console.log('网络超时，请到历史记录查看')
          overtime = -1
        } else if (betResult == 0) {
          res = `lottery-in-border-green-deg${Math.floor(Math.random() * (2 - 1 + 1)) + 1}`
        } else if (betResult == 1) {
          res = `lottery-in-border-blue-deg${Math.floor(Math.random() * (2 - 1 + 1)) + 1}`
        } else if (betResult == 2) {
          res = `lottery-in-border-purple-deg${Math.floor(Math.random() * (2 - 1 + 1)) + 1}`
        } else if (betResult == 3) {
          res = `lottery-in-border-red-deg${Math.floor(Math.random() * (2 - 1 + 1)) + 1}`
        } else if (betResult == 4) {
          res = `lottery-in-border-yellow-deg${Math.floor(Math.random() * (2 - 1 + 1)) + 1}`
        }

        if (overtime == -1 && this.state.overtime != -1) {
          this.setState({
            overtime: overtime
          })
        }
        if (this.state.showDeg != res) {
          this.setState({
            showDeg: res
          })
        }

      }
      if (leftTime == 44) {
        if (this.state.showThisResult != false) {
          this.setState({
            showThisResult: false
          })
        }
      }

      let t1 = 30 //0-24可以押注
      let t2 = 40 //25-34转动
      let t3 = 45 //35-39查看结果
      let ten = 0
      let single = 0

      if (leftTime <= t1) {
        single = (t1 - leftTime) % 10
        ten = (t1 - leftTime - single) / 10
      } else if (leftTime <= t2) {
        single = (t2 - leftTime) % 10
        ten = (t2 - leftTime - ((t2 - leftTime) % 10)) / 10
      } else if (leftTime <= t3) {
        single = (t3 - leftTime) % 10
        ten = (t3 - leftTime - single) / 10
      }
      tsNow++
      // console.log('时间', this.state.stateTime, this.state.ten, this.state.single)
    }, 1000)
  }

  // by lucas
  // 提交金币
  postGoldToHost = async (leftTime) => {
    // console.log('提交金币pre', leftTime)
    if ((this.state.canRunTimer == 0 && leftTime <= 30) || (leftTime > 26 && leftTime <= 30)) {
      let wheels = [
        { wheelId: 0, coins: this.state.gem1tmp.gold },
        { wheelId: 1, coins: this.state.gem2tmp.gold },
        { wheelId: 2, coins: this.state.gem3tmp.gold },
        { wheelId: 3, coins: this.state.gem4tmp.gold },
        { wheelId: 4, coins: this.state.gem5tmp.gold }
      ]
      if (
        this.state.gem1tmp.gold > 0 ||
        this.state.gem2tmp.gold > 0 ||
        this.state.gem3tmp.gold > 0 ||
        this.state.gem4tmp.gold > 0 ||
        this.state.gem5tmp.gold > 0
      ) {
        this.setState({
          gem1tmp: {
            number: 0,
            gold: 0
          },
          gem2tmp: {
            number: 0,
            gold: 0
          },
          gem3tmp: {
            number: 0,
            gold: 0
          },
          gem4tmp: {
            number: 0,
            gold: 0
          },
          gem5tmp: {
            number: 0,
            gold: 0
          }
        })
        this.lotteryStore.BetGold(wheels)
      }
    }

    if ((this.lotteryStore.data.isEnd == false && leftTime == 31)) {
      if (
        this.state.gem1tmp.gold == 0 &&
        this.state.gem2tmp.gold == 0 &&
        this.state.gem3tmp.gold == 0 &&
        this.state.gem4tmp.gold == 0 &&
        this.state.gem5tmp.gold == 0
      ) {
        console.log('清空')
        this.setState({
          gem1: {
            number: 0,
            gold: 0
          },
          gem2: {
            number: 0,
            gold: 0
          },
          gem3: {
            number: 0,
            gold: 0
          },
          gem4: {
            number: 0,
            gold: 0
          },
          gem5: {
            number: 0,
            gold: 0
          },
          domList1: [],
          domList2: [],
          domList3: [],
          domList4: [],
          domList5: [],
        })
      }
    }
  }
  // by lucas end

  // 清空初始化金币
  resetBet() {
    this.setState({
      gem1: {
        number: 0,
        gold: 0
      },
      gem2: {
        number: 0,
        gold: 0
      },
      gem3: {
        number: 0,
        gold: 0
      },
      gem4: {
        number: 0,
        gold: 0
      },
      gem5: {
        number: 0,
        gold: 0
      },
      domList1: [],
      domList2: [],
      domList3: [],
      domList4: [],
      domList5: [],
      wheels: [
        { wheelId: 0, coins: 0 },
        { wheelId: 1, coins: 0 },
        { wheelId: 2, coins: 0 },
        { wheelId: 3, coins: 0 },
        { wheelId: 4, coins: 0 }
      ],
      showDeg: '',
      gemArr: []
    })
  }

  // 押注金额
  stakeChange(coins) {
    if (this.state.stakeObj != coins) {
      this.setState({
        stakeObj: coins
      })
    }
  }

  // 添加金币
  addGold = async (val) => {
    if (this.state.canRunTimer != 2) {
      this.setState({
        canRunTimer: 2
      })
    }
    let { userInfo, coins } = this.lotteryStore.data
    let { gem1, gem2, gem3, gem4, gem5, stakeObj } = this.state
    let allGold = stakeObj + gem1.gold + gem2.gold + gem3.gold + gem4.gold + gem5.gold

    // by lucas
    let allGoldWillBet =
      this.state.gem1tmp.gold +
      this.state.gem2tmp.gold +
      this.state.gem3tmp.gold +
      this.state.gem4tmp.gold +
      this.state.gem5tmp.gold
    let allGoldWillBet2 =
      this.state.gem1.gold + this.state.gem2.gold + this.state.gem3.gold + this.state.gem4.gold + this.state.gem5.gold
    // console.log(userInfo.gold, userInfo.gold, allGoldWillBet, allGoldWillBet2)
    // if (userInfo.gold == 0 || userInfo.gold < allGoldWillBet || userInfo.gold < allGoldWillBet2) {
    console.log(allGold)
    if (
      userInfo.gold == 0 ||
      userInfo.gold < allGold ||
      coins == 0 ||
      coins < allGold ||
      userInfo.gold < allGoldWillBet2
    ) {
      console.log('金币不足')
      this.setState({
        goldEnough: 0
      })
      return
    }
    let selectCoins = this.state.stakeObj
    if (val == '1') {
      let gemArr = this.state.gemArr
      let has = gemArr.includes('gem1')
      if (!has) {
        if (gemArr.length > 2) {
          return
        } else {
          gemArr.push('gem1')
          if (this.state.gem1tmp != {
            number: this.state.gem1tmp.number + 1,
            gold: this.state.gem1tmp.gold + selectCoins
          }) {
            this.setState({
              gemArr,
              gem1tmp: {
                number: this.state.gem1tmp.number + 1,
                gold: this.state.gem1tmp.gold + selectCoins
              }
            })
          }
        }
      }
      if (this.state.gem1tmp != {
        number: this.state.gem1tmp.number + 1,
        gold: this.state.gem1tmp.gold + selectCoins
      }) {
        this.setState({
          gem1tmp: {
            number: this.state.gem1tmp.number + 1,
            gold: this.state.gem1tmp.gold + selectCoins
          }
        })
      }
    }
    if (val == '2') {
      let gemArr = this.state.gemArr
      let has = gemArr.includes('gem2')
      if (!has) {
        if (gemArr.length > 2) {
          return
        } else {
          gemArr.push('gem2')
          if (this.state.gem2tmp != {
            number: this.state.gem2tmp.number + 1,
            gold: this.state.gem2tmp.gold + selectCoins
          }) {
            this.setState({
              gemArr,
              gem2tmp: {
                number: this.state.gem2tmp.number + 1,
                gold: this.state.gem2tmp.gold + selectCoins
              }
            })
          }
        }
      }
      if (this.state.gem2tmp != {
        number: this.state.gem2tmp.number + 1,
        gold: this.state.gem2tmp.gold + selectCoins
      }) {
        this.setState({
          gem2tmp: {
            number: this.state.gem2tmp.number + 1,
            gold: this.state.gem2tmp.gold + selectCoins
          }
        })
      }
    }
    if (val == '3') {
      let gemArr = this.state.gemArr
      let has = gemArr.includes('gem3')
      if (!has) {
        if (gemArr.length > 2) {
          return
        } else {
          gemArr.push('gem3')
          if (this.state.gem3tmp != {
            number: this.state.gem3tmp.number + 1,
            gold: this.state.gem3tmp.gold + selectCoins
          }) {
            this.setState({
              gemArr,
              gem3tmp: {
                number: this.state.gem3tmp.number + 1,
                gold: this.state.gem3tmp.gold + selectCoins
              }
            })
          }
        }
      }
      if (this.state.gem3tmp != {
        number: this.state.gem3tmp.number + 1,
        gold: this.state.gem3tmp.gold + selectCoins
      }) {
        this.setState({
          gem3tmp: {
            number: this.state.gem3tmp.number + 1,
            gold: this.state.gem3tmp.gold + selectCoins
          }
        })
      }
    }
    if (val == '4') {
      let gemArr = this.state.gemArr
      let has = gemArr.includes('gem4')
      if (!has) {
        if (gemArr.length > 2) {
          return
        } else {
          gemArr.push('gem4')
          if (this.state.gem4tmp != {
            number: this.state.gem4tmp.number + 1,
            gold: this.state.gem4tmp.gold + selectCoins
          }) {
            this.setState({
              gemArr,
              gem4tmp: {
                number: this.state.gem4tmp.number + 1,
                gold: this.state.gem4tmp.gold + selectCoins
              }
            })
          }

        }
      }
      if (this.state.gem4tmp != {
        number: this.state.gem4tmp.number + 1,
        gold: this.state.gem4tmp.gold + selectCoins
      }) {
        this.setState({
          gem4tmp: {
            number: this.state.gem4tmp.number + 1,
            gold: this.state.gem4tmp.gold + selectCoins
          }
        })
      }
    }
    if (val == '5') {
      let gemArr = this.state.gemArr
      let has = gemArr.includes('gem5')
      if (!has) {
        if (gemArr.length > 2) {
          return
        } else {
          gemArr.push('gem5')
          if (this.state.gem5tmp != {
            number: this.state.gem5tmp.number + 1,
            gold: this.state.gem5tmp.gold + selectCoins
          }) {
            this.setState({
              gemArr,
              gem5tmp: {
                number: this.state.gem5tmp.number + 1,
                gold: this.state.gem5tmp.gold + selectCoins
              }
            })
          }
        }
      }
      if (this.state.gem5tmp != {
        number: this.state.gem5tmp.number + 1,
        gold: this.state.gem5tmp.gold + selectCoins
      }) {
        this.setState({
          gem5tmp: {
            number: this.state.gem5tmp.number + 1,
            gold: this.state.gem5tmp.gold + selectCoins
          }
        })
      }
    }
    // by lucas end

    // 金币节点
    let ChildDom = `
    <div class="gold-sbg"
    style="bottom: ${(Math.floor(Math.random() * (3 - 10)) + 10) / 10 + 'rem'};
    left: ${(Math.floor(Math.random() * (1 - 8)) + 8) / 10 + 'rem'};
    "
    ></div>`

    // 宝石背景高亮
    if (this.state.domState != val) {
      this.setState({
        domState: val
      })
    }
    if (val == '1') {
      if (this.state.gem1 != { number: this.state.gem1.number + 1, gold: this.state.gem1.gold + this.state.stakeObj }) {
        this.setState({
          domList1: [...this.state.domList1, ChildDom],
          gem1: { number: this.state.gem1.number + 1, gold: this.state.gem1.gold + this.state.stakeObj }
        })
      }
    } else if (val == '2') {
      if (this.state.gem2 != { number: this.state.gem2.number + 1, gold: this.state.gem2.gold + this.state.stakeObj }) {
        this.setState({
          domList2: [...this.state.domList2, ChildDom],
          gem2: { number: this.state.gem2.number + 1, gold: this.state.gem2.gold + this.state.stakeObj }
        })
      }
    } else if (val == '3') {
      if (this.state.gem3 != { number: this.state.gem3.number + 1, gold: this.state.gem3.gold + this.state.stakeObj }) {
        this.setState({
          domList3: [...this.state.domList3, ChildDom],
          gem3: { number: this.state.gem3.number + 1, gold: this.state.gem3.gold + this.state.stakeObj }
        })
      }
    } else if (val == '4') {
      if (this.state.gem4 != { number: this.state.gem4.number + 1, gold: this.state.gem4.gold + this.state.stakeObj }) {
        this.setState({
          domList4: [...this.state.domList4, ChildDom],
          gem4: { number: this.state.gem4.number + 1, gold: this.state.gem4.gold + this.state.stakeObj }
        })
      }
    } else if (val == '5') {
      this.setState({
        domList5: [...this.state.domList5, ChildDom],
        gem5: { number: this.state.gem5.number + 1, gold: this.state.gem5.gold + this.state.stakeObj }
      })
    }

    this.audioValue.play()
    // this.audioLottery.play()
    // this.audioLottery.pause()
  }

  FuncTabBarRank(val) {
    if (this.state.funcTabBarRank != val) {
      this.setState({
        funcTabBarRank: (this.state.funcTabBarRank = val)
      })
    }
  }
  FuncTabBarHis(val) {
    if (this.state.funcTabBarHis != val) {
      this.setState({
        funcTabBarHis: (this.state.funcTabBarHis = val)
      })
    }
  }
  FuncTabBarRule(val) {
    if (this.state.funcTabBarRule != val) {
      this.setState({
        funcTabBarRule: (this.state.funcTabBarRule = val)
      })
    }
  }

  rankData() {
    this.lotteryStore.getBetRank()
  }
  HisData() {
    this.lotteryStore.getBetHistory()
  }

  render() {
    let { language, lang, funcTabBar, gem1, gem2, gem3, gem4, gem5, showThisResult, stateLottery } = this.state
    let { onlyOne, userInfo, rounds, coins, betResult, rankList, historyList, rewardCoins, betFruit, allPeopleBet } =
      this.lotteryStore.data

    let showThisResult1 = showThisResult
    // 押注遮罩
    let isBetMark = {
      display: (this.state.stateMask == 2) ? 'none' : 'block'
    }
    // 转盘遮罩
    let lotteryMark = { display: stateLottery == 1 ? 'block' : 'none' }
    // 问号
    let questionShow = { display: stateLottery == 2 ? 'block' : 'none' }
    // 倒计时数字
    let countDownShow = {
      display: (stateLottery == 1) || (stateLottery == 3) ? 'block' : 'none'
    }
    // 动态显示金币
    let coinsCount = coins - gem1.gold - gem2.gold - gem3.gold - gem4.gold - gem5.gold
    // 所有人赌注渲染
    let allPeopleBetArr = allPeopleBet
    return (
      <div className={`lottery-out-wrap-box ${language == 'ar' && 'arlang'}`}>
        <div className="shadow-bg" style={{ display: stateLottery == 3 ? 'block' : 'none' }}></div>
        <div className="win-bg" style={{ display: stateLottery == 3 ? 'block' : 'none' }}></div>
        <div className="circle-bg" style={{ display: stateLottery == 3 ? 'block' : 'none' }}></div>
        <div className="red-light"></div>
        {/* 超时弹窗 */}
        <div className="overtime" style={{ display: betFruit == -1 ? 'block' : 'none' }}>
          <div className="net">{lang.networkout}</div>
          <div
            className="qd"
            onClick={() => {
              if (this.state.betFruit != 2) {
                this.setState({ betFruit: 2 })
              }
            }}
          >
            {lang.ok}
          </div>
        </div>
        {/* 金币不足弹窗 */}
        <div className="no-gold" style={{ display: this.state.goldEnough == 1 ? 'none' : 'block' }}>
          {lang.nogold}
          <div
            className="qd"
            onClick={() => {
              if (this.state.goldEnough != 1) {
                this.setState({ goldEnough: 1 })
              }
            }}
          >
            {lang.ok}
          </div>
        </div>
        {/* 关闭 */}
        <div className="close-btn" onClick={() => this.closeWebview()}></div>
        {/* 帮助 */}
        <div
          className="help-btn"
          onClick={() => {
            this.FuncTabBarRule('1')
          }}
        ></div>
        {/* 排行榜 */}
        <div
          className="rank-btn"
          onClick={() => {
            this.FuncTabBarRank('1')
            this.rankData()
          }}
        ></div>
        {/* 历史记录 */}
        <div
          className="history-btn"
          onClick={() => {
            this.FuncTabBarHis('1')
            this.HisData()
          }}
        ></div>
        <div className={`gold-bg ${language == 'ar' && 'arlang'}`}>
          <span>{lang.round}&nbsp;</span>
          <span>{rounds}</span>
        </div>
        {/* 转盘 */}
        <div className="lottery-out-border"></div>
        {/* 转盘遮罩 */}
        <div className="lottery-mark" style={lotteryMark}></div>
        {/* 转盘 */}
        <div
          className={`lottery-in-border
          ${(stateLottery == 1 || stateLottery == 3) ? '' : 'lottery-in-border-active'}
          ${this.state.showDeg}
          `}
        ></div>
        {/* 灯光效果 */}
        <div className="lottery-light1"></div>
        {/* 指针 */}
        <div className="pointer"></div>
        {/* 问号 */}
        <div className="question-mark" style={questionShow}></div>
        {/* 倒计时 */}
        {/* <div className="countdown-mark" style={countDownShow}>
          <span>{ten}</span>
          <span>{single}</span>
        </div> */}
        <Timer returnleftTime={this.returnleftTime.bind(this)} countDownShow={countDownShow} />
        {/* 压票 */}
        <div className="ticket-wrap">
          <div className={`ticket-border ${this.state.domState == '1' ? 'ticket-border-active' : ''}`}>
            <div className="bs-wrap" onClick={this.addGold.bind(this, '1')}>
              <div className="title">{(allPeopleBetArr.length > 0 && allPeopleBetArr[0].coins) || 0}</div>
              <div className="bs"></div>
              <img className="pic" src="/img/activity/lottery/1.png" alt="" />
              <div className="gold_mum">{score(gem1.gold)}</div>
              {this.state.domList1.map((item, index) => {
                return <div key={index} dangerouslySetInnerHTML={{ __html: item || '' }}></div>
              })}
            </div>
          </div>
          <div className={`ticket-border ${this.state.domState == '2' ? 'ticket-border-active' : ''}`}>
            <div className="bs-wrap" onClick={this.addGold.bind(this, '2')}>
              <div className="title">{(allPeopleBetArr.length > 1 && allPeopleBetArr[1].coins) || 0}</div>
              <div className="bs"></div>
              <img className="pic" src="/img/activity/lottery/2.png" alt="" />
              <div className="gold_mum">{score(gem2.gold)}</div>
              {this.state.domList2.map((item, index) => {
                return <div key={index} dangerouslySetInnerHTML={{ __html: item || '' }}></div>
              })}
            </div>
          </div>
          <div className={`ticket-border ${this.state.domState == '3' ? 'ticket-border-active' : ''}`}>
            <div className="bs-wrap" onClick={this.addGold.bind(this, '3')}>
              <div className="title">{(allPeopleBetArr.length > 2 && allPeopleBetArr[2].coins) || 0}</div>
              <div className="bs"></div>
              <img className="pic" src="/img/activity/lottery/3.png" alt="" />
              <div className="gold_mum">{score(gem3.gold)}</div>
              {this.state.domList3.map((item, index) => {
                return <div key={index} dangerouslySetInnerHTML={{ __html: item || '' }}></div>
              })}
            </div>
          </div>
          <div className={`ticket-border ${this.state.domState == '4' ? 'ticket-border-active' : ''}`}>
            <div className="bs-wrap" onClick={this.addGold.bind(this, '4')}>
              <div className="title">{(allPeopleBetArr.length > 3 && allPeopleBetArr[3].coins) || 0}</div>
              <div className="bs"></div>
              <img className="pic" src="/img/activity/lottery/4.png" alt="" />
              <div className="gold_mum">{score(gem4.gold)}</div>
              {this.state.domList4.map((item, index) => {
                return <div key={index} dangerouslySetInnerHTML={{ __html: item || '' }}></div>
              })}
            </div>
          </div>
          <div className={`ticket-border ${this.state.domState == '5' ? 'ticket-border-active' : ''}`}>
            <div className="bs-wrap" onClick={this.addGold.bind(this, '5')}>
              <div className="title">{(allPeopleBetArr.length > 4 && allPeopleBetArr[4].coins) || 0}</div>
              <div className="bs"></div>
              <img className="pic" src="/img/activity/lottery/5.png" alt="" />
              <div className="gold_mum">{score(gem5.gold)}</div>
              {this.state.domList5.map((item, index) => {
                return <div key={index} dangerouslySetInnerHTML={{ __html: item || '' }}></div>
              })}
            </div>
          </div>
        </div>
        <div className="steps"></div>
        <div className="base">
          <div className="gold_num">
            <span>{coinsCount < 0 ? '0' : score(coinsCount)}</span>
            <img src="/img/activity/lottery/jb.png" alt="" />
          </div>
        </div>
        {/* 金额 */}
        <div className="gold-bet">
          <div
            className={`gold-box1 ${this.state.stakeObj == this.state.coins1 ? 'gold-box1-active' : ''}`}
            onClick={this.stakeChange.bind(this, this.state.coins1)}
          ></div>
          <div
            className={`gold-box2 ${this.state.stakeObj == this.state.coins2 ? 'gold-box2-active' : ''}`}
            onClick={this.stakeChange.bind(this, this.state.coins2)}
          ></div>
          <div
            className={`gold-box3 ${this.state.stakeObj == this.state.coins3 ? 'gold-box3-active' : ''}`}
            onClick={this.stakeChange.bind(this, this.state.coins3)}
          ></div>
          <div
            className={`gold-box4 ${this.state.stakeObj == this.state.coins4 ? 'gold-box4-active' : ''}`}
            onClick={this.stakeChange.bind(this, this.state.coins4)}
          ></div>
          <div
            className={`gold-box5 ${this.state.stakeObj == this.state.coins5 ? 'gold-box5-active' : ''}`}
            onClick={this.stakeChange.bind(this, this.state.coins5)}
          ></div>
        </div>
        {/* 历史记录 */}
        {
          this.state.funcTabBarHis == '1' && (
            <History
              language={language}
              lang={lang}
              funcTabBarHis={this.state.funcTabBarHis}
              closeFuncTabBarHis={() => this.FuncTabBarHis('0')}
              historyList={historyList}
            />
          )
        }
        {
          this.state.funcTabBarRule == '1' && (
            <Rule
              language={language}
              lang={lang}
              funcTabBarRule={this.state.funcTabBarRule}
              closeFuncTabBarRule={() => this.FuncTabBarRule('0')}
            />
          )
        }
        {
          this.state.funcTabBarRank == '1' && (
            <Rank
              language={language}
              lang={lang}
              funcTabBarRank={this.state.funcTabBarRank}
              closeFuncTabBarRank={() => this.FuncTabBarRank('0')}
              rankList={rankList}
            />
          )
        }
        {/* 是否押注遮罩 */}
        <div className="bet-mark" style={isBetMark}></div>
        {/* 获奖提示 */}
        <div className="win-wrap" style={{ display: showThisResult1 ? 'block' : 'none' }}>
          <div
            className="win-box"
            onClick={() => {
              if (this.state.showThisResult != false) {
                this.setState({
                  showThisResult: false
                })
              }
            }}
          >
            <div className="win-title">
              {lang.round} {rounds}
            </div>
            <div className="win-content" style={{ display: betFruit == -2 ? 'none' : 'block' }}>
              <div className="pic">
                <img src={`/img/activity/lottery/${betFruit + 1}.png`} alt="" />
              </div>
              <div className="pic-bg"></div>
              <div className="money">
                <div className="jb" style={{ display: onlyOne == 1 ? 'none' : 'block' }}>
                  <span dangerouslySetInnerHTML={{ __html: lang.gainGold.replace('。。。', rewardCoins) }}></span>
                </div>
                <div
                  style={{
                    fontSize: '0.26rem',
                    margin: '0 auto',
                    marginTop: '0.2rem',
                    width: '5rem',
                    display: onlyOne == 1 ? 'block' : 'none'
                  }}
                >
                  ({lang.invalid.replace('11', rewardCoins)})
                </div>
              </div>
            </div>
            <div style={{ display: betFruit == -2 ? 'block' : 'none' }} className="his-look">
              {lang.networkout}
            </div>
          </div>
        </div>
        <audio
          src={this.state.mp3}
          ref={(audio) => {
            this.audioValue = audio
          }}
        ></audio>
        <div className={`hide`}>
          <img src="/img/activity/lottery/1_y.png" />
          <img src="/img/activity/lottery/5_y.png" />
          <img src="/img/activity/lottery/10_y.png" />
          <img src="/img/activity/lottery/50_y.png" />
          <img src="/img/activity/lottery/100_y.png" />
          <img src="/img/activity/lottery/ticket2.png" />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/lottery/index.js